import React from 'react';
import { StaticVerticalStepper, StaticVerticalStepperContent } from '@frontend/static-vertical-stepper';
import { Accordion } from '../common-components/accordion';

type HistoryProps = {
  history: StaticVerticalStepperContent[];
};

export const History = React.memo(({ history }: HistoryProps) => {
  if (!history || history.length === 0) {
    return null; // Return null if there is no history to display
  }

  return (
    <Accordion accordionId='history' accordionTitle='History'>
      <StaticVerticalStepper stepsInfo={history} />
    </Accordion>
  );
});

History.displayName = 'History';
